<template>
    <div id="printing_type" class="field">
        <label>
            {{ $t('ui.toolbox.core_waybills_label_svg.labels.printing_type') }}
        </label>

        <div v-dropdown class="ui selection dropdown" v-if="is_initialized">
            <div
                class="text"
                v-for="label_info in papers_label_infos"
                v-if="current_printing_type == `Label::${label_info.name}`">
                {{ get_printing_type(label_info) }}
            </div>
            <i class="dropdown icon"></i>
            <div class="menu">
                <div
                    v-for="label_info in papers_label_infos"
                    @click="current_printing_type = `Label::${label_info.name}`"
                    class="item"
                    :class="{
                        'selected active': current_printing_type == `Label::${label_info.name}`
                    }">
                    {{ get_printing_type(label_info) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "ToolCoreWaybillsLabelSvgNewLabelPrintingType",
    props: {
        channel: String,
        printing_type: {
            type: String,
            default: "Label::Default"
        },
        scope: {
            type: String,
            default: "provider"
        }
    },
    data() {
        return {
            is_initialized: false,
            is_processing: true,
            current_printing_type: "",
        }
    },
    computed: {
        current_node_identity() {
            if (this.scope == 'provider') {
                return this.$store.state.provider.node.identity
            } else if (this.scope == 'customer') {
                return this.$store.state.customer.customer.provider_node.identity
            }
            return null
        },
        papers_label_infos() {
            return this.$store.state[this.scope].papers_label_infos || {}
        }
    },
    created() {
    },
    mounted() {
        this.init()
    },
    watch: {
        printing_type: {
            immediate: true,
            handler(value) {
                this.current_printing_type = value
            }
        },
        current_printing_type(value) {
            if (this.channel) {
                this.$bus.$emit(this.channel, value)
            }
        },
    },
    methods: {
        async init() {
            this.is_initialized = false
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        get_printing_type(label_info) {
            let note = ""
            let result = this.$t('ui.toolbox.core_waybills_label_svg.printing_types["Label::' + label_info.name+ '"]')
            if (label_info.style) {
                if (label_info.style.height != 100 || label_info.style.width != 100) {
                    note = ` (${label_info.style.height}x${label_info.style.width}mm)`
                }
            }
            return result + note
        },
    },
    components: {
    },
}
</script>
